<template>
    <div>
        <router-link to="/main-hall">
            <div class="portal">
                <a>
                </a>
            </div>
        </router-link>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.portal
{
    background-image: url("../../assets/medias/images/portal.png");
    background-size: 20vh;
    background-repeat: no-repeat;
    height:26vh;
    width:11vw;
}

.portal:hover{
    background-image: url("../../assets/medias/images/portalOn.png");
    background-repeat: no-repeat;
    transition: .1s;
    cursor: url('../../assets/medias/images/cursor-right.png'), pointer;
}

@media (min-width: 768px) and (max-width: 1024px) {
    .portal{
        // background-size: vh;
        width: 14vw;
    }
}

@media only screen and (min-device-width: 1366px) and (max-device-height: 1024px) and (-webkit-min-device-pixel-ratio: 2)  and (orientation: landscape)  {
        .portal{
        // background-size: vh;
        width: 14vw;
    }
}
</style>